import { ChangeDetectionStrategy, Component, ElementRef, Renderer2 } from '@angular/core';
import { FireAndFlowerSaleCardStackContentViewModel } from './fire-and-flower-sale-card-stack-content-view-model';
import { PrintCardContentComponent } from '../../shared/print-card-content.component';

@Component({
  selector: 'app-fire-and-flower-sale-card-stack-content',
  templateUrl: './fire-and-flower-sale-card-stack-content.component.html',
  styleUrls: ['./fire-and-flower-sale-card-stack-content.component.scss'],
  providers: [FireAndFlowerSaleCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FireAndFlowerSaleCardStackContentComponent extends PrintCardContentComponent {
  constructor(
    public override viewModel: FireAndFlowerSaleCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
